export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'dx_access_token',
  AUTH_STATE: 'dx_auth_state',
  AUTH_REDIRECT_URI: 'dx_auth_redirect_uri',
  AUTH_VERIFIER: 'dx_auth_verifier',
} as const;
